<script>
import baseEdit from '@/views/components/base/baseEdit.vue'
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: 'work',
      items: [
      ],
      forms: {},
    }
  },
  created() {
    // this.loadLevelData()
    // this.loadCommunityDrop()

    // let query = this.$route.query
    // if (query.category_id) {
    //   this.forms.category_id = query.category_id
    // }

    // // !非管理员必须选小区
    // if (!this.isRoot) {
    //   this.items[this.getItemIndex('scope_type')].value = 2
    //   this.items[this.getItemIndex('scope_type')].disabled = true
    // }
  },
  methods: {
    // onselect(val) {
    //   if (val == 1) {
    //     // this.items[2].type = 'kong'
    //     this.items[this.getItemIndex('community_id')].type = 'kong'
    //     this.forms.community_id = ''
    //   }
    //   if (val == 2) {
    //     //  this.items[2].type = 'select'
    //     this.items[this.getItemIndex('community_id')].type = 'select'
    //   }
    // },
    // initData() {
    //   // 加载详情数据
    //   $form.initData(this, {}, (res) => {
    //     if (res.scope_type == 1) {
    //       // this.items[2].type = 'kong'
    //       this.items[this.getItemIndex('community_id')].type = 'kong'
    //       this.forms.community_id = ''
    //     }
    //     if (res.scope_type == 2) {
    //       //  this.items[2].type = 'select'
    //       this.items[this.getItemIndex('community_id')].type = 'select'
    //     }
    //     if (res) {
    //       this.forms = res
    //     }
    //   })
    // },
    // loadLevelData() {
    //   // 通过pk查询字典数据
    //   let q = {}
    //   $utils.api.load('serviceCategoryDropTree', q).then((res) => {
    //     if (res && res.data) {
    //       let ll = res.data
    //       let dropList = []
    //       for (let index = 0; index < ll.length; index++) {
    //         const element = ll[index]
    //         let xx = {}
    //         xx.value = element.category_id
    //         xx.name = element.name
    //         xx.children = element.children || []
    //         dropList.push(xx)
    //       }
    //       for (let index = 0; index < this.items.length; index++) {
    //         const element = this.items[index]
    //         if (element && element.name == 'category_id') {
    //           // this.items[index]['dropList'] = dropList
    //           this.items[index]['dropList'] = (this.items[index]['dropList'] || []).concat(dropList)
    //         }
    //       }
    //     }
    //   })
    // },
    // loadCommunityDrop() {
    //   // 通过pk查询字典数据
    //   let q = {}
    //   $utils.api.load('communityDrop', q).then((res) => {
    //     if (res && res.data) {
    //       let ll = res.data.list
    //       let dropList = []
    //       for (let index = 0; index < ll.length; index++) {
    //         const element = ll[index]
    //         let xx = {}
    //         xx.value = element.community_id
    //         xx.name = element.community_name
    //         dropList.push(xx)
    //       }
    //       for (let index = 0; index < this.items.length; index++) {
    //         const element = this.items[index]
    //         if (element && element.name == 'community_id') {
    //           this.items[index]['dropList'] = dropList
    //         }
    //       }
    //     }
    //   })
    // },
  },
}
</script>
